import React, { useState } from "react";
import { Drawer } from "@/components/ui/drawer";
import { PlusIcon } from "@heroicons/react/24/outline";
import AddTransactionDetail from "./AddTransactionDetail";

interface AddTransactionProps {
  children?: React.ReactNode;
  className?: string;
  controlledOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const AddTransaction: React.FC<AddTransactionProps> = ({
  children,
  className,
  controlledOpen,
  onOpenChange,
}) => {
  const [internalOpen, setInternalOpen] = useState(false);

  const isControlled = controlledOpen !== undefined;
  const open = isControlled ? controlledOpen : internalOpen;

  const toggleDrawer = () => {
    if (isControlled) {
      onOpenChange?.(!open);
    } else {
      setInternalOpen(!open);
    }
  };

  const renderTrigger = () => {
    if (children) {
      return (
        <div onClick={toggleDrawer} className={className}>
          {children}
        </div>
      );
    }

    return (
      <button
        onClick={toggleDrawer}
        className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold bg-green-700 hover:bg-green-800 text-white transition-colors"
      >
        <PlusIcon className="h-5 w-5" />
        Add Transaction
      </button>
    );
  };

  return (
    <div>
      {renderTrigger()}

      <Drawer
        title="Add New Transaction"
        placement="right"
        onClose={toggleDrawer}
        open={open}
        width="max-w-[600px]"
      >
        <div className="flex flex-col gap-4 w-full">
          <span className="font-medium text-foreground">Select type</span>
          <AddTransactionDetail
            open={open}
            setOpen={isControlled ? onOpenChange : setInternalOpen}
          />
        </div>
      </Drawer>
    </div>
  );
};

export default AddTransaction;
